var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.22 107.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5552e2;}.cls-2{fill:#6e63fb;}.cls-3{fill:#fff;}.cls-4{fill:#2f2bb2;}.cls-5{fill:#2a2aa8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "221.46 13.75 218.89 102.67 268.98 102.83 271.22 2.42 264.71 1.91 221.46 13.75"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.83 11.74 0.25 100.67 51.35 100.82 53.58 0.41 46.09 0.02 2.83 11.74"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.08 6.67 43.2 101.08 43.17 102 39.9 102.54 37.26 102.99 35.44 103.28 34.2 103.48 31.57 103.92 28.53 104.44 25.87 104.88 22.82 105.38 20.18 105.82 17.15 106.34 15.17 106.66 14.51 106.76 14.51 106.63 11.48 106.52 8.87 106.42 5.83 106.31 5.14 106.28 3.21 106.21 0.28 106.16 0.28 100.67 2.83 17.78 6.55 16.82 9.19 16.16 12.24 15.37 14.9 14.68 17.96 13.89 20.62 13.22 23.68 12.43 26.32 11.74 29.37 10.95 32.01 10.29 35.07 9.5 37.73 8.81 40.78 8.02 43.45 7.36 46.08 6.67"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.24 8.69 264.24 8.7 261.3 104.03 254.6 105.14 224.24 106.16 218.15 107.17 220.99 19.81 221.03 19.8 224.41 18.92 226.58 18.37 227.05 18.26 230.1 17.47 232.76 16.78 235.82 15.99 238.48 15.3 240.96 14.68 241.54 14.54 242.27 14.35 244.18 13.85 247.23 13.06 249.87 12.39 252.92 11.6 255.59 10.92 258.65 10.13 261.3 9.43 264.24 8.69"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.19 16.16 6.43 90.35 6.04 100.73 5.83 106.31 5.14 106.28 3.21 106.21 3.42 100.7 6.55 16.82 9.19 16.16"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.9 14.68 12.08 90.42 11.69 100.78 11.48 106.52 8.87 106.42 9.08 100.75 9.46 90.39 12.24 15.37 14.9 14.68"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.62 13.22 17.74 90.49 17.36 100.83 17.15 106.34 15.17 106.66 14.51 106.76 14.51 106.63 14.73 100.81 15.12 90.46 17.96 13.89 20.62 13.22"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.32 11.74 22.82 105.38 20.18 105.82 23.68 12.43 26.32 11.74"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.01 10.29 28.53 104.44 25.87 104.88 29.37 10.95 32.01 10.29"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.73 8.81 34.2 103.48 31.57 103.92 35.06 9.5 37.73 8.81"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.45 7.35 39.9 102.54 37.26 102.98 40.78 8.02 43.45 7.35"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "227.05 18.26 223.67 105.28 221.03 105.72 224.41 18.92 227.05 18.26"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "232.76 16.78 229.36 106.34 226.73 106.79 230.1 17.47 232.76 16.78"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "238.48 15.3 235.06 107.41 232.42 107.83 235.82 15.99 238.48 15.3"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "244.18 13.85 240.72 106.44 238.09 106.89 241.54 14.54 244.18 13.85"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "249.87 12.39 246.44 105.51 243.78 105.95 247.23 13.06 249.87 12.39"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "255.59 10.91 252.11 104.55 249.47 104.99 252.93 11.6 255.59 10.91"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "261.31 9.43 257.81 103.61 255.17 104.05 258.64 10.12 261.31 9.43"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "35.83 90.71 35.58 98.75 35.51 101.01 35.44 103.28 35.31 107.41 15.17 106.66 14.51 106.76 14.51 106.63 11.48 106.52 8.87 106.42 5.83 106.31 5.14 106.28 5.31 100.72 5.39 97.93 5.64 90.34 6.43 90.35 9.46 90.39 12.08 90.42 15.12 90.46 17.74 90.49 20.75 90.53 23.37 90.56 26.4 90.59 29.04 90.63 32.06 90.66 34.68 90.7 35.83 90.71"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "254.91 95.66 254.6 105.14 224.24 106.16 224.71 95.73 227.21 95.72 229.83 95.72 232.88 95.71 235.49 95.7 238.5 95.69 241.13 95.69 244.17 95.68 246.81 95.67 249.82 95.67 252.44 95.67 254.91 95.66"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2.83 17.78 2.83 11.74 46.08 0 46.08 6.66 2.83 17.78"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "221.03 19.8 221.03 13.76 264.71 1.91 264.29 8.69 221.03 19.8"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5.56 90.34 12 90.42 11.61 100.78 5.23 100.72 5.56 90.34"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "224.63 95.73 231.08 95.7 230.68 106.17 224.3 106.11 224.63 95.73"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0.25 100.67 43.26 100.65 269.01 102.13 269.01 107.73 43.26 107.71 0 106.15 0.25 100.67"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0.25 100.67 0 106.15 43.26 107.71 43.26 100.65 0.25 100.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFl);
export default __webpack_public_path__ + "static/media/FL.83bba62ed7474904d8e618e006c4b314.svg";
export { ForwardRef as ReactComponent };